module.exports = __webpack_public_path__ + "static/media/ikebukuro-hanakawado-5.6903de7c.jpg";